/**
 * Chailease.FileCenter.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FileConvertService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 上傳Word檔案後，轉Pdf檔案
     *
     * @param iFormFile
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileConvertPostWordConvertToPDFPostForm(iFormFile?: Blob, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public fileConvertPostWordConvertToPDFPostForm(iFormFile?: Blob, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public fileConvertPostWordConvertToPDFPostForm(iFormFile?: Blob, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public fileConvertPostWordConvertToPDFPostForm(iFormFile?: Blob, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (iFormFile !== undefined) {
            formParams = formParams.append('iFormFile', <any>iFormFile) as any || formParams;
        }

        return this.httpClient.request<any>('post',`${this.basePath}/FileConvert/PostWordConvertToPDF`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
